export default {
    indicator_group_1: 'Underlying Risks',
    indicator_group_2: 'Vaccines',
    indicator_group_3: 'Behavioural Risks',
};
